import React, { useEffect } from 'react';
import { useStyles } from "../styles/styles";
import { getDecimal } from "../global/utils";
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from "@mui/material/Typography";
import ListItemText from '@mui/material/ListItemText';

const LineItem = (props) => {
    const balance = props.balance;
    const classes = useStyles;

    useEffect(() => {
        if (balance.lineItems && balance.lineItems.length > 0) {
            balance.lineItems = balance.lineItems.filter(item => item.amount > 0);
        } else {
            balance.lineItems = null;
        }
    }, [balance]);

    return (
        <>
            <List sx={{ ...classes.list }}>
                <ListItem alignItems='flex-start' sx={classes.listPadding}>
                    <ListItemText
                        sx={classes.listText}
                        primary={
                            <Grid container spacing={1} sx={{
                                alignItems: "top"
                            }}>
                                <Grid size={12}>
                                    <Typography variant='subtitle2' component='span' sx={{ fontWeight: 'bold', marginLeft: '-5px' }}>Balance Subtotals:</Typography>
                                </Grid>
                            </Grid>
                        }
                        primaryTypographyProps={{
                            component: 'span',
                            color: 'textPrimary',
                            sx: { fontSize: '.9rem', lineHeight: '.7rem' },
                        }}
                    />
                </ListItem>
                {balance.lineItems && balance.lineItems.length > 0 && (
                    balance.lineItems.map((itm) => (
                        <ListItem alignItems='flex-start' disableGutters sx={{ paddingTop: '0', paddingBottom: '0' }} key={itm.id}>
                            <ListItemText
                                sx={classes.listText}
                                primary={(
                                    <Grid container spacing={0.5} sx={{
                                        alignItems: "top"
                                    }}>
                                        <Grid size={8}>{itm.description}</Grid>
                                        <Grid size={1}>
                                            {getDecimal(itm.amount)}
                                        </Grid>
                                    </Grid>
                                )}
                                primaryTypographyProps={{
                                    component: 'span',
                                    color: 'textPrimary',
                                    sx: { fontSize: '.85rem', lineHeight: '.7rem', paddingLeft: '.2rem' },
                                }}
                            />
                        </ListItem>
                    ))
                )}
            </List>
        </>
    );
}

export default LineItem;